<template>
  <div class="event">
    <ccs-header
      :title="`Мероприятия.${event.short_name}`"
      :back="true"/>
    <div class="event-menu">
      <menu-tab v-for="(tab, index) in allowedTabs" :key="index"
        :to="tab.to" :text="tab.text" :params="tab.params"/>
    </div>
    <div class="event-content">
        <router-view/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import { PermissionsList } from '@/helpers/permissions';

import Header from '@/layouts/Header.vue';
import MenuTab from '@/components/MenuTab.vue';

export default {
  name: 'EventBase',
  components: {
    'ccs-header': Header,
    MenuTab,
  },
  data() {
    return {
      tabs: [
        {
          text: 'Осн. инфо.',
          to: 'base_info',
          requiredPermissions: [
            PermissionsList.EventView,
            PermissionsList.EventViewAll,
          ],
        }, {
          text: 'Доп. инфо.',
          to: 'add_info',
          requiredPermissions: [
            PermissionsList.EventView,
            PermissionsList.EventViewAll,
          ],
        /*}, { Legacy
          text: 'Пользователи',
          to: 'event_users',
          requiredPermissions: [
            PermissionsList.EventView,
            PermissionsList.EventViewAll,
          ],*/
        }, {
          text: 'Сотрудники ФНД',
          to: 'event_employees',
          params: { page: 1 },
          requiredPermissions: [
            PermissionsList.FndView,
          ],
        }, {
          text: 'Проекты',
          to: 'event_projects',
          params: { page: 1 },
        }, {
          text: 'База знаний',
          to: 'event_knowledge_base',
        }, {
          text: 'Компетенции',
          to: 'event_skills',
          requiredPermissions: [
            PermissionsList.EventSkillView,
            PermissionsList.EventSkillViewAll,
          ],
        }, {
          text: 'Пакеты',
          to: 'packages',
          params: { page: 1 },
          requiredPermissions: [
            PermissionsList.PackageView,
          ],
        }, {
          text: 'Трансферы',
          to: 'event_transfers',
          params: { page: 1 },
          requiredPermissions: [
            PermissionsList.TransferView,
          ],
        }, /*{
          text: 'Дипломы',
          to: 'diplomas',
          requiredPermissions: [
            PermissionsList.EventView,
            PermissionsList.EventSkillViewAll,
          ],
        },*/
      ],
    };
  },
  computed: {
    ...mapState('events', ['event']),
    ...mapState('session', ['permissions']),
    allowedTabs() {
      return this.tabs.filter(tab => this.isAccessAllowed(tab.requiredPermissions));
    },
  },
  methods: {
    ...mapActions('events', ['getEvent']),
    ...mapMutations('events', ['setEventID']),
    isAccessAllowed(requiredPermissions) {;
      let result = false;
      if (!requiredPermissions) {
        result = true;
        return result;
      } else {
        requiredPermissions.forEach(slug => {
          result = result || this.permissions[slug];
        });
        return result;
      }
    },
  },
  async created() {
    this.setEventID(this.$route.params.eventID);
    await this.getEvent();
  },
};
</script>

<style lang="scss" scoped>
.event {
  min-height: 100%;
  min-width: 100%;
  background: $neutralLightest;

  &-content {
    padding: 25px 33px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background: #fff;
  }

  &-menu {
    max-width: 100%;
    margin: 0 33px 0 33px;
    display: flex;
    overflow: auto;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
      height: 3px;
    }

    &::-webkit-scrollbar-track {
      background: $primaryLightest + 50;
      border-radius: 50px;
    }

    &::-webkit-scrollbar-thumb {
      max-height: 3px;
      background: $primaryLight;
      border-radius: 50px;
    }

  }

}
</style>
